<template>
  <div class="takeTaxiBox" @click="clickAll" v-if="rawData || errorMsg">
    <div class="outSideBox">
      <div class="contentBox">
        <div class="titleBox">
          <img
            src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/takeTaxiIcon.png"
            alt=""
            class="takeTaxiIcon"
          />
          <div class="titleText">聚合打车</div>
        </div>
        <div class="infoBox" :class="{ isExpire: isExpire }" v-if="rawData">
          <div class="infoItem">
            <div class="pointBox">
              <div class="point blue"></div>
            </div>
            <div class="label blue">起点</div>
            <div class="placeText">{{ rawData.start }}</div>
          </div>
          <div class="infoItem">
            <div class="pointBox">
              <div class="point orange"></div>
            </div>
            <div class="label orange">终点</div>
            <div class="placeText">{{ rawData.end }}</div>
          </div>
        </div>
        <div class="infoBox2" :class="{ isExpire: isExpire }" v-if="rawData">
          <div class="line"></div>
          <div class="infoBox2Content">
            <div class="leftBox">
              <div class="line1">
                <span class="span1">预估</span>
                <span class="span2"
                  >{{ rawData.totalFeeMin }}-{{ rawData.totalFeeMax }}</span
                >
                <span class="span1">元</span>
              </div>
              <div class="line2">
                <span class="span">已选</span>
                <span class="span">{{ rawData.vehicleName }}</span>
              </div>
            </div>
            <div class="rightBox" @click="clickBtn">立即打车</div>
          </div>
        </div>
        <!-- 错误信息 -->
        <div
          class="errorMsgBox"
          v-if="errorMsg != ''"
          :class="{ isExpire: isExpire }"
        >
          {{ errorMsg }}
        </div>
        <!-- 查看更多 -->
        <div
          class="bottomBar"
          :class="{ isExpire: isExpire }"
          v-if="errorMsg != '' || type == 'metroFare'"
          @click="clickMoreBtn"
        >
          <div class="moreBox">
            <div class="text">查看更多</div>
            <img
              class="right_arrow_gray"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/v3/right_arrow_gray.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const config = {
  dxlc: {
    test: "https://lzgj.test.brightcns.cn/take-taxi/",
    prod: "https://h5-lzgj.brightcns.com/take-taxi/",
  },
};
const env = process.env.VUE_APP_ENV;
export default {
  props: ["businessContent"],
  data: function () {
    return {
      timer: null,
      isExpire: false,
      expireTime: null,
      rawData: null,
      errorMsg: "",
    };
  },
  methods: {
    // 检测卡片是否过期
    checkIsExpire: function (businessContent) {
      let expireTime = new Date(
        businessContent.expireTime.replace(/-/g, "/")
      ).getTime();
      let nowTime = new Date().getTime();
      if (nowTime > expireTime) {
        this.isExpire = true;
      } else {
        console.log("卡片过期时间", expireTime - nowTime);
        this.timer = setTimeout(() => {
          this.isExpire = true;
          clearTimeout(this.timer);
          this.timer = null;
        }, expireTime - nowTime);
      }
    },
    // 点击立即打车
    clickBtn: function () {
      if (this.isExpire) {
        return;
      }
      let bizReq = JSON.parse(this.businessContent.bizReq);
      let arriveAddress = bizReq.arriveAddress.address;
      let arriveAddressLng = bizReq.arriveAddress.longitude;
      let arriveAddressLat = bizReq.arriveAddress.latitude;
      let departAddress = bizReq.departAddress.address;
      let departAddressLng = bizReq.departAddress.longitude;
      let departAddressLat = bizReq.departAddress.latitude;
      this.jumpToH5(
        arriveAddress,
        arriveAddressLng,
        arriveAddressLat,
        departAddress,
        departAddressLng,
        departAddressLat
      );
    },
    // 点击整个卡片
    clickAll: function () {
      if (this.isExpire) {
        this.$toast("已失效");
        setTimeout(() => {
          this.jumpToH5();
        }, 1000);
      }
    },
    // 点击查看更多
    clickMoreBtn: function () {
      if (this.isExpire) {
        return;
      }
      this.jumpToH5();
    },
    jumpToH5: function (
      arriveAddress,
      arriveAddressLng,
      arriveAddressLat,
      departAddress,
      departAddressLng,
      departAddressLat
    ) {
      let url = config[this.businessContent.channel][env];
      url =
        url +
        `#/OutsideLoginPage?sessionId=${window.localStorage.getItem(
          "sessionId"
        )}`;
      if (arriveAddress && departAddress) {
        url =
          url +
          `&departAddress=${departAddress}&departAddressLng=${departAddressLng}&departAddressLat=${departAddressLat}&arriveAddress=${arriveAddress}&arriveAddressLng=${arriveAddressLng}&arriveAddressLat=${arriveAddressLat}`;
      }
      window.location.href = url;
    },
  },
  mounted: function () {
    if (this.businessContent.bizCode == "SUCCESS") {
      this.type = this.businessContent.type;
      this.rawData = JSON.parse(this.businessContent.bizData);
      if (this.type == "lineDetail") {
        this.rawData.busesRe = this.rawData.buses.reverse();
      }
      console.log(this.rawData);
    } else {
      this.errorMsg = this.businessContent.bizMsg;
    }
    this.checkIsExpire(this.businessContent);
  },
  destroyed: function () {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./takeTaxiBox.scss";
</style>
